'use client';
import styled from 'styled-components';
import { Steps } from '../CheckoutHeader/styles';

export const Wrapper = styled.div`
  width: 100vw;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.background.base};
  ${Steps} {
    width: 100%;
  }
  @media ${({ theme }) => theme.tablet} {
    overflow: auto;
  }
`;

export const HeaderContainer = styled.div`
  position: relative;
  top: 0;
  text-align: center;
  padding: ${props => props.theme.spacing(2)};
  color: ${props => props.theme.colors.text.lightest};
  min-height: 340px;

  @media ${props => props.theme.laptop} {
    padding: ${props => props.theme.spacing(3, 0)};
  }
`;

export const FullHeadline = styled.h1`
  ${({ theme }) => theme.typography.heading3}
`;

export const FullSubheadline = styled.p`
  ${props => props.theme.typography.body};

  margin: ${props => props.theme.spacing(2)} auto 0;
  padding: ${props => props.theme.spacing(2, 0, 4)};

  button {
    text-decoration: underline;
    ${props => props.theme.typography.body};
  }
`;

export const ProductCardContainer = styled.div`
  max-width: 100%;
  @media ${({ theme }) => theme.tablet} {
    max-width: 360px;
    margin: auto;
  }
`;

export const StyledRecommendedPlanContainer = styled.div`
  position: relative;
  z-index: 1;
  padding: 0 5px;
  margin-bottom: ${({ theme }) => theme.spacing(34)};
  @media ${({ theme }) => theme.mobileM} {
    padding: 0;
    margin-bottom: ${({ theme }) => theme.spacing(8)};
  }

  fieldset {
    border: none;
    margin: 0;
    padding: 0;
    min-width: unset;
  }
  legend {
    ${({ theme }) => theme.typography.heading5}
    margin: 0 auto ${({ theme }) => theme.spacing(5)};
  }
`;

export const StyledForm = styled.form``;

export const PlanContainer = styled.div`
  margin: auto;
  margin-top: ${props => props.theme.spacing(6)};
  width: fit-content;
  max-width: 360px;
  min-height: 270px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  ${props => props.theme.typography.heading4}

  @media ${({ theme }) => theme.tablet} {
    margin-top: ${props => props.theme.spacing(6)};
  }
`;

export const PlanTitle = styled.h4`
  ${props => props.theme.typography.heading4}
  margin:${props => props.theme.spacing(4, 2, 1)}
`;

export const PlanDescription = styled.div`
  margin: ${props => props.theme.spacing(1, 2)};
`;

export const Badge = styled.div`
  position: absolute;
  top: -15px;
  left: 0;
  @media ${({ theme }) => theme.tablet} {
    top: -15px;
    left: -20px;
  }
`;

export const PricesContainer = styled.div`
  margin-left: ${props => props.theme.spacing(2)};
`;

export const StrikeThroughPrice = styled.span`
  ${({ theme }) => theme.typography.body}
  ${({ theme }) => theme.fontFamily.base}
  margin-right: ${({ theme }) => theme.spacing(2)};
  text-decoration-line: line-through;
  text-transform: capitalize;
  color: ${({ theme }) => theme.colors.status.successPrimary};
`;

export const DisplayedPrice = styled.span`
  ${({ theme }) => theme.typography.bodyBold}
  ${({ theme }) => theme.fontFamily.base}
	margin-right: ${({ theme }) => theme.spacing(1)};
`;
export const BackgroundImage = styled.div`
  bottom: 0;
  display: 'block';
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: -1;
  img {
    height: 100%;
  }
  max-height: 320px;
`;

export const SectionHeader = styled.h5`
  ${props => props.theme.typography.heading5};
  text-align: center;
  padding: ${props => props.theme.spacing(3, 0)};
  position: relative;
`;

export const SelectionText = styled.p`
  ${props => props.theme.typography.body};
  color: ${props => props.theme.colors.text.tertiary};
  padding: ${props => props.theme.spacing(1, 6, 2)};
`;

export const MenuText = styled.div`
  ${props => props.theme.typography.button};
  color: ${props => props.theme.colors.text.primary};
  display: flex;
  flex-direction: ${props => props.direction};
  align-items: ${props => (props.direction === 'row' ? 'center' : 'start')};
  gap: ${props => props.direction === 'column' && '6px'};
  span {
    font-weight: bold;
    display: block;
    width: 100%;
  }
`;

export const CollapsibleMenuTitleSection = styled.div`
  display: flex;
`;

export const CollapsibleMenuWrapper = styled.div`
  display: block;
  margin: 0 auto;
  max-width: 345px;
`;

export const MenuImageWrapper = styled.div`
  margin-right: ${props => props.theme.spacing(2)};
  max-height: 44px;
`;
